import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Section } from '../../section';
import { errorTypes } from '../../messages';

export const QuestionsSections = ({
  questionsSectionsConfig,
  questions,
  sectionKey = null,
  ...rest
}) => {
  const displaySection = (section) => !sectionKey || section === sectionKey;
  return (
    <Fragment>
      {questionsSectionsConfig.map(
        ({ key, url, title, ...sectionRest }) =>
          displaySection(url) && (
            <Section
              {...rest}
              {...sectionRest}
              key={title}
              title={title}
              questions={questions.RETRIEVED_QUESTIONS.filter(({ section }) => section === key)}
              formName="AboutYouFormState"
              errorMessage={`${key}:${errorTypes.QUESTION_FIELD_ERROR}`}
            />
          ),
      )}
    </Fragment>
  );
};

QuestionsSections.propTypes = {
  questionsSectionsConfig: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  questions: PropTypes.shape({
    RETRIEVED_QUESTIONS: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  formSectionName: PropTypes.string.isRequired,
  sectionKey: PropTypes.string,
};
